export const etudiants = (state) => state.etudiants
